import { cms } from '@shared/config/axios';

export default {
  getPageBySlug(slug) {
    return cms.$get(`/pages/?slug=${slug}`);
  },
};
